export default {
  arr: {
    default: () => ([]),
    type: Array
  },
  checked: Boolean,
  outline: Boolean,
  value: String,
  disabled: Boolean,
  label: String,
  state: {
    default: 'primary'
  },
  size: String,
  light: Boolean
}


// WEBPACK FOOTER //
// ./src/components/Checkbox/_props.js